import axiosInstance from "../api";
import {
  GET_CATEGARY,
  GET_SKILLS,
  GET_DEGREE,
  GET_PROFICIENCY,
  GET_LANGUAGE,
  GET_SUBCATEGARY,
  GET_DELIVERY_TYPE,
  GET_INDUSTRY,
  GET_PENALTY,
  GET_PRIORITY,
  GET_RATING,
  GET_SKILLS_WITH_CATEGORY,
} from "../constants";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";

export const getCategary = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=2`);
    if (response?.data?.status) {
      dispatch({ type: GET_CATEGARY, categarylist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getWithParentCategary = (pid) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=2&parent_id=${pid}`);
    if (response?.data?.status) {
      dispatch({ type: GET_CATEGARY, categarylist: response?.data?.response });
      return response?.data;
    }
    urtoast(response?.data?.response?.message, 2);
    return response?.data;
  } catch (err) {
    //urtoast(err.message, 2);
  }
};


export const getSkills = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=6`);
    if (response?.data?.status) {
      dispatch({ type: GET_SKILLS, skilllist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getSkillswithCategory = (ids) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=6&category_id=${ids}`);
    if (response?.data?.status) {
      dispatch({ type: GET_SKILLS_WITH_CATEGORY, skilllistwithcategory: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getDegree = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=7`);
    if (response?.data?.status) {
      dispatch({ type: GET_DEGREE, degreelist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getProficiency = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=8`);
    if (response?.data?.status) {
      dispatch({
        type: GET_PROFICIENCY,
        proficiencylist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getLanguage = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=4`);
    if (response?.data?.status) {
      dispatch({ type: GET_LANGUAGE, languagelist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getIndustry = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=1`);
    if (response?.data?.status) {
      dispatch({ type: GET_INDUSTRY, industrylist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getSubcategary = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `category?type=3&parent_id=${id}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_SUBCATEGARY,
        subcategarylist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getDeliveryType = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=9`);
    if (response?.data?.status) {
      dispatch({
        type: GET_DELIVERY_TYPE,
        deliverytypelist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getPenalty = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=10`);
    if (response?.data?.status) {
      dispatch({ type: GET_PENALTY, penaltylist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getPriority = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=11`);
    if (response?.data?.status) {
      dispatch({ type: GET_PRIORITY, prioritylist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getRating = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=12`);
    if (response?.data?.status) {
      dispatch({ type: GET_RATING, ratinglist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
